import { FrameSelectorFieldMui } from '@app/components/form/FrameSelectorFieldMui';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { SelectElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';

export function TikTokThumbFields({ videoUrl }: { videoUrl?: string }) {
  const { setValue } = useFormContext();
  const thumbType = useWatch({ name: 'thumbType' });
  const { $t } = useIntl();

  useEffect(() => {
    if (thumbType === 'DEFAULT') {
      setValue('coverOffsetMs', null);
    }
  }, [thumbType, setValue]);

  return (
    <Box>
      <Box sx={{ width: 300 }}>
        <SelectElement
          name="thumbType"
          label={$t({
            id: 'common.thumbType',
            defaultMessage: 'Tipo de thumbnail',
          })}
          options={[
            {
              id: 'DEFAULT',
              label: 'Default',
            },
            {
              id: 'VIDEO_FRAME',
              label: $t({
                id: 'common.videoFrame',
                defaultMessage: 'Frame de vídeo',
              }),
            },
          ]}
          fullWidth
        />
      </Box>

      {thumbType === 'VIDEO_FRAME' && (
        <Box sx={{ width: 300, mt: 2 }}>
          <FrameSelectorFieldMui unit={'ms'} name={'coverOffsetMs'} videoUrl={videoUrl} />
        </Box>
      )}
    </Box>
  );
}
